import RadioButtonQuest from "../../../../UI/RadioButtonQuest";

const MaintainedCreditBalance = ({ onSelectAnswer, backClick, clsName }) => {
  const optionHandle = async (e) => {
    if (e.target.value === "288") {
      onSelectAnswer(e);
    } else if (e.target.value === "289") {
      onSelectAnswer(e);
    }
  };

  return (
    <div className={`qsSlider slidea5 ${clsName}`}>
      <h2 className="qs-title slide-up-now">
        {" "}
        I had not maintained a positive balance for a significant period of
        time, (including falling back into your overdraft shortly after pay
        day,) which ought to have made the bank aware of my financial
        difficulties - do you agree???
      </h2>
      <ul className="btn-option optinal-items  two-options  slide-up-now">
        <li>
          <div className=" option_but ">
            <RadioButtonQuest
              key="cred1"
              className="radio"
              labelName="Agree"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="288"
              name="maintainedCreditBalance"
              id="cred1"
              dataQuestId={104}
              dataAnsId={288}
              dataAnsLabel="Agree"
            />
          </div>
        </li>
        <li>
          <div className="option_but btn-next ">
            <RadioButtonQuest
              key="cred2"
              className="radio"
              labelName="Disagree"
              labelClassName="align-items-center justify-content-center btn-next next5"
              onClick={optionHandle}
              value="289"
              name="maintainedCreditBalance"
              id="cred2"
              dataQuestId={104}
              dataAnsId={289}
              dataAnsLabel="Disagree"
            />
          </div>
        </li>
      </ul>
    </div>
  );
};

export default MaintainedCreditBalance;
